import { MATERIALS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";

export const FlatMaterialService = {
  getAll: (params: IPagination) => requests.get(`${MATERIALS_URL}/flat-materials`, params),
  updateStatus: (id: number, isFlatOnly: boolean) =>
    requests.patch(`${MATERIALS_URL}/material-flat/status/${id}`, { isFlatOnly }),
  delete: (id: number) => requests.delete(`${MATERIALS_URL}/${id}`),
};
